import React, { Component } from "react";

import {
	Row,
	Col,
	Card,
	CardBody,
	CardHeader,
	Container,
	Button,
	FormGroup,
	Label,
	CustomInput,
	CardFooter,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Table,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import Swal from "sweetalert2";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import {
	getProductGroupsList,
	ProductChangeValue,
	ProductSelecteChangeValue,
	BaseunitSelecteChangeValue,
	ProductUnitsValue,
	ProductVendorsValue,
	ProductImage,
	ProductGroupValue,
	ProductAdd,
	getProductRowData,
	GroupChangeValue,
	model_close,
	units_model_open,
	units_model_close,
	apiError,
	UnitsChangeValue,
	DeleteUnitsRow,
} from "../../../store/Masters/Products/actions";
import { pGroupModel_open } from "../../../store/Masters/ProductGroups/actions";

import {
	getMiniDepartment,
	getMiniVendors,
	getMiniSections,
	getMiniCategorys,
	getMiniTaxs,
	getMiniBasicUnits,
} from "../../../store/Mini/actions";
// import state from "sweetalert/typings/modules/state";
import "./Products.scss";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

class AddProducts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			leftSideBarType: "icon",
			bymodel: false,
			imagePreviewUrl: null,
			columnDefs: [
				{
					headerName: "Units",
					field: "name",
				},
				{
					headerName: "Conversion",
					field: "units",
					valueParser: numberParser,
				},
			],
			defaultColDef: {
				flex: 1,
				minWidth: 110,
				editable: true,
				resizable: true,
			},
		};

		this.ChangeHandeler = this.ChangeHandeler.bind(this);
		this.groupChangeHandeler = this.groupChangeHandeler.bind(this);

		this.handleValidSubmit = this.handleValidSubmit.bind(this);
		this.handleUnitsSubmit = this.handleUnitsSubmit.bind(this);
	}

	componentDidMount() {
		this.setState({
			bymodel: this.props.CPmodel ? true : false,
		});
		this.props.apiError();
		this.props.getProductGroupsList();
		this.props.getMiniDepartment();
		this.props.getMiniVendors();
		this.props.getMiniSections();
		this.props.getMiniCategorys();
		this.props.getMiniBasicUnits();
		this.props.getMiniTaxs();
		var id = 0;
		if (this.props.CPmodel) {
			id = this.props.openId;
		} else {
			id = this.props.match.params.id;
		}

		if (id !== 0 && id !== "0") {
			this.setState((prevState) => ({
				id: parseInt(id),
				defaultColDef: {
					...prevState.defaultColDef,
					editable: false,
				},
			}));

			this.props.getProductRowData(id, this.props.history);
		} else {
			this.setState({
				id: 0,
			});
		}
	}

	onGridReady = (params) => {
		this.gridApi = params.api;
	};
	onAddRow = () => {
		this.gridApi.updateRowData({
			add: [{ name: "", units: "" }],
		});
	};

	ChangeHandeler(e) {
		this.props.ProductChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}
	groupChangeHandeler(e) {
		this.props.GroupChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}
	UnitsChangeHandeler(e) {
		this.props.UnitsChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}

	handleImageChange(e) {
		e.preventDefault();

		let reader = new FileReader();
		let file = e.target.files[0];
		// var url = reader.readAsDataURL(file);

		reader.onloadend = () => {
			this.setState({
				imagePreviewUrl: reader.result,
			});
		};
		if (e.target.files.length !== 0) {
			this.props.ProductImage(e.target.files[0]);
			reader.readAsDataURL(file);
		} else {
			this.props.ProductImage({});
			this.setState({
				imagePreviewUrl: null,
			});
		}
	}
	handleUnitsSubmit() {
		this.props.ProductUnitsValue({
			name: this.props.ProductUnits.name,
			units: this.props.ProductUnits.units,
			dodelete: false,
		});
	}
	deleteUnits(index) {
		this.props.DeleteUnitsRow(index);
	}
	handleValidSubmit() {
		// var allunits = [];
		// this.gridApi.forEachNode((rowNode, index) => {
		//   var item = {
		//     name: rowNode.data.name,
		//     units: rowNode.data.units,
		//   };
		//   allunits.push(item);
		// });
		// this.props.ProductUnitsValue(allunits);
		var data = this.props.rowdata;

		// if(data.vendors)
		data.vendor_ids = data.vendors
			? data.vendors.map((Vendor, index) => {
					return Vendor.value;
			  })
			: [];

		if (data.department_id != null) {
			if (data.category_id != null) {
				if (data.type != null) {
					if (data.section_id != null) {
						if (data.tax_id != null) {
							// if (data.vendors.length !== 0) {
							if (data.baseunit_id != null) {
								if (data.group_id != null) {
									this.props.ProductAdd(
										data,
										this.props.image,
										this.state.id,
										this.props.history,
										this.state.bymodel ? true : false,
										this.props.type
									);
								} else {
									Swal.fire({
										icon: "error",
										title: "Select Group ?",
									});
								}
							} else {
								Swal.fire({
									icon: "error",
									title: "Select Baseunit ?",
								});
							}
							// } else {
							//   Swal.fire({
							//     icon: "error",
							//     title: "Select Vendors ?",
							//   });
							// }
						} else {
							Swal.fire({
								icon: "error",
								title: "Select Tax ?",
							});
						}
					} else {
						Swal.fire({
							icon: "error",
							title: "Select Section ?",
						});
					}
				} else {
					Swal.fire({
						icon: "error",
						title: "Select Type ?",
					});
				}
			} else {
				Swal.fire({
					icon: "error",
					title: "Select Category ?",
				});
			}
		} else {
			Swal.fire({
				icon: "error",
				title: "Select Department ?",
			});
		}
	}
	onGroupid(id, name) {
		this.props.GroupChangeValue({
			key: "parent",
			value: id,
		});
		this.props.GroupChangeValue({
			key: "parent_name",
			value: name,
		});
		this.props.ProductGroupValue(id);
	}

	render() {
		let { imagePreviewUrl } = this.state;
		let $imagePreview = null;
		const typeOptions = [
			{ id: 1, name: "MATERIAL" },
			{ id: 2, name: "SERVICE" },
		];

		if (imagePreviewUrl) {
			$imagePreview = (
				<img
					className="product-img"
					alt="User"
					src={imagePreviewUrl}
					style={{
						height: "250px",
						width: "350px",
						cursor: "pointer",
					}}
				/>
				// <img
				//   className="img-thumbnail"
				//   alt="User"
				//   src={imagePreviewUrl}
				//   style={{
				//     height: "250px",
				//     width: "350px",
				//     cursor: "pointer",
				//   }}
				// />
			);
		} else if (this.state.bymodel || this.props.rowdata?.image) {
			$imagePreview = (
				<img
					className="product-img"
					alt="User"
					src={
						this.props.rowdata.image
							? this.props.rowdata?.image
							: DefaultImg
					}
					style={{
						height: "250px",
						width: "350px",
						cursor: "pointer",
					}}
				/>
			);
		} else {
			$imagePreview = (
				<div
					className="img-thumbnail text-center W-100 pt-2 "
					style={{
						height: "250px",
						width: "350px",
						cursor: "pointer",
					}}>
					<i className="ri-upload-cloud-line ri-8x"></i>
					<br />
					<span className="font-size-16">Select Product Image</span>
				</div>
			);
		}

		const classes = makeStyles({
			root: {
				height: 110,
				flexGrow: 1,
				maxWidth: 400,
			},
		});
		const renderTree = (nodes) => (
			<TreeItem
				key={nodes.id}
				nodeId={nodes.id}
				label={nodes.name}
				onClick={() => this.onGroupid(nodes.id, nodes.name)}>
				{Array.isArray(nodes.children)
					? nodes.children.map((node) => renderTree(node))
					: null}
			</TreeItem>
		);
		return (
			<React.Fragment>
				<div className={!this.state.bymodel ? "page-content" : ""}>
					<Container fluid>
						<Card>
							<AvForm
								className="form-horizontal"
								onValidSubmit={this.handleValidSubmit}>
								<CardHeader className="bg-transparent border-bottom">
									{!this.state.bymodel && (
										<Link to="/Products">
											<i className="ri-arrow-go-back-fill font-size-18"></i>
										</Link>
									)}
									<h5 className="card-title-18 d-inline-block ml-2">
										Add New Product
									</h5>
									<div className="float-right">
										<Button
											type="submit"
											color="primary"
											className="mr-2">
											Save
										</Button>
										{!this.state.bymodel && (
											<Button
												type="button"
												color="light"
												href="/Products">
												Cancel
											</Button>
										)}
										{this.state.bymodel && (
											<Button
												type="button"
												color="light"
												onClick={this.props.Close}>
												Cancel
											</Button>
										)}
									</div>
								</CardHeader>
								<CardBody>
									<Row className="justify-content-center">
										<Col xs={3}>
											<CardHeader className="bg-transparent border-bottom ">
												<h3 className="card-title-15 d-inline-block">
													GROUPS
												</h3>
												{!this.state.bymodel && (
													<div className="float-right">
														<Button
															type="button"
															color="primary"
															size="sm"
															className="waves-effect waves-light"
															onClick={() =>
																this.props.pGroupModel_open()
															}>
															<i className="mdi mdi-plus-circle-outline mr-2"></i>
															Add Group
														</Button>
													</div>
												)}
											</CardHeader>

											<CardBody>
												{this.props.grouplist && (
													<TreeView
														className={classes.root}
														multiSelect={false}
														defaultCollapseIcon={
															<ExpandMoreIcon />
														}
														// defaultExpanded={this.props.rowdata?.group?.id}
														selected={[
															this.props.rowdata
																?.group?.id,
														]}
														// onNodeSelect={handleSelect}
														defaultExpandIcon={
															<ChevronRightIcon />
														}>
														{this.props.grouplist.map(
															(i) => renderTree(i)
														)}
													</TreeView>
												)}
												<Label className="text-danger m-0">
													{
														this.props.error_msg
															?.group_id
													}
												</Label>
											</CardBody>
										</Col>

										<Col xs={9}>
											<CardHeader className="bg-transparent border-bottom">
												<h3 className="card-title-15">
													Product Details
												</h3>
											</CardHeader>
											<CardBody>
												<Row className="justify-content-center">
													<Col md={6}>
														<Row>
															<Col
																md={12}
																className="mb-0">
																<FormGroup className="mb-0">
																	<Label className="col-form-label p-0">
																		Product
																		Name
																	</Label>

																	<AvField
																		className="mb-0 form-control "
																		type="text"
																		value={
																			this
																				.props
																				.rowdata
																				.name
																		}
																		onChange={
																			this
																				.ChangeHandeler
																		}
																		id="Product-Name-text-input"
																		name="name"
																		placeholder="Product Name"
																		validate={{
																			required:
																				{
																					value: true,
																				},
																			// pattern: { value: "^[A-Za-z0-9]+$" },
																			// minLength: { value: 6 },
																			// maxLength: { value: 16 },
																		}}
																	/>
																</FormGroup>
																<Label className="text-danger m-0">
																	{
																		this
																			.props
																			.error_msg
																			?.name
																	}
																</Label>
															</Col>
														</Row>
														<Row>
															<Col
																md={6}
																className="mb-0">
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="department_id_select"
																		className=" col-form-label p-0">
																		Select
																		Department
																	</Label>

																	<Select
																		id="department_id_select"
																		name="department_id_select"
																		classNamePrefix="select2-selection"
																		isClearable={
																			this
																				.props
																				.rowdata
																				?.departmentLabel
																				? true
																				: false
																		}
																		options={this.props.deparmentslist.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.rowdata
																				.departmentLabel,
																			value: this
																				.props
																				.rowdata
																				.department_id,
																		}}
																		onChange={(
																			e
																		) => {
																			this.props.ProductSelecteChangeValue(
																				{
																					key: "departmentLabel",
																					label: e?.label,
																					key2: "department_id",
																					value: e?.value,
																				}
																			);
																		}}
																	/>
																	<Label className="text-danger m-0">
																		{
																			this
																				.props
																				.error_msg
																				?.department_id
																		}
																	</Label>
																</FormGroup>
															</Col>
															<Col
																md={6}
																className="mb-0">
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="Category_id_select"
																		className=" col-form-label p-0 ">
																		Select
																		Category
																	</Label>

																	<Select
																		id="Category_id_select"
																		name="Category_id_select"
																		classNamePrefix="select2-selection"
																		options={this.props.categoryList.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.rowdata
																				.categoryLabel,
																			value: this
																				.props
																				.rowdata
																				.category_id,
																		}}
																		onChange={(
																			e
																		) => {
																			this.props.ProductSelecteChangeValue(
																				{
																					key: "categoryLabel",
																					label: e.label,
																					key2: "category_id",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																	<Label className="text-danger m-0">
																		{
																			this
																				.props
																				.error_msg
																				?.category_id
																		}
																	</Label>
																</FormGroup>
															</Col>

															<Col
																md={6}
																className="mb-0">
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="Category_type_select"
																		className=" col-form-label p-0 ">
																		Select
																		Type
																	</Label>

																	<Select
																		id="Category_type_select"
																		name="Category_type_select"
																		classNamePrefix="select2-selection"
																		options={typeOptions.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.rowdata
																				.categoryTypeLabel,
																			value: this
																				.props
																				.rowdata
																				.type,
																		}}
																		onChange={(
																			e
																		) => {
																			this.props.ProductSelecteChangeValue(
																				{
																					key: "categoryTypeLabel",
																					label: e.label,
																					key2: "type",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																	<Label className="text-danger m-0">
																		{
																			this
																				.props
																				.error_msg
																				?.type
																		}
																	</Label>
																</FormGroup>
															</Col>

															<Col md={6}>
																<FormGroup>
																	<Label
																		htmlFor="Section_id_select"
																		className=" col-form-label p-0">
																		Select
																		Section
																	</Label>
																	<Select
																		id="Section_id_select"
																		name="Section_id_select"
																		classNamePrefix="select2-selection"
																		options={this.props.sectionlist.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.rowdata
																				.sectionLabel,
																			value: this
																				.props
																				.rowdata
																				.section_id,
																		}}
																		onChange={(
																			e
																		) => {
																			this.props.ProductSelecteChangeValue(
																				{
																					key: "sectionLabel",
																					label: e.label,
																					key2: "section_id",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																	<span className="text-danger mt-0">
																		{
																			this
																				.props
																				.error_msg
																				?.section_id
																		}
																	</span>
																</FormGroup>
															</Col>
															<Col md={6}>
																<FormGroup className="m-0">
																	<Label
																		htmlFor="Section_id_select"
																		className=" col-form-label p-0">
																		Select
																		Tax
																	</Label>

																	<Select
																		id="tax_id_select"
																		name="tax_id_select"
																		classNamePrefix="select2-selection"
																		options={this.props.Taxlist.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.rowdata
																				? this
																						.props
																						.rowdata
																						.taxLabel
																				: this
																						.props
																						.rowdata
																						.department
																						.name,
																			value: this
																				.props
																				.rowdata
																				.tax_id,
																		}}
																		onChange={(
																			e
																		) => {
																			this.props.ProductSelecteChangeValue(
																				{
																					key: "taxLabel",
																					label: e.label,
																					key2: "tax_id",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																	<span className="text-danger mt-0">
																		{
																			this
																				.props
																				.error_msg
																				?.tax_id
																		}
																	</span>
																</FormGroup>
															</Col>
															<Col md={12}>
																<FormGroup className="m-0">
																	<Label
																		htmlFor="Vendorlist"
																		className=" col-form-label p-0">
																		Select
																		Vendors
																	</Label>

																	<Select
																		id="Vendorlist"
																		name="Vendorlist"
																		isMulti
																		classNamePrefix="select-vendorlist"
																		options={this.props.vendorslist.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={
																			this
																				.props
																				.rowdata &&
																			this
																				.props
																				.rowdata
																				.vendors
																		}
																		onChange={(
																			vendorvalues
																		) =>
																			this.props.ProductVendorsValue(
																				vendorvalues
																			)
																		}
																		loading={
																			this
																				.props
																				.vendorsLoading
																		}
																		onInputChange={(
																			inputValue,
																			{
																				action,
																			}
																		) => {
																			// Only trigger search on user input, not on select/deselect
																			if (
																				action ===
																				"input-change"
																			) {
																				this.props.getMiniVendors(
																					{
																						...this
																							.props
																							.vendorParams,
																						page: 1,
																						page_size: 10,
																						search: inputValue,
																					}
																				);
																			}
																		}}
																		onMenuOpen={() => {
																			this.props.getMiniVendors(
																				{
																					...this
																						.props
																						.vendorParams,
																					page: 1,
																					page_size: 10,
																					search: "",
																				}
																			);
																		}}
																		// onMenuClose={() => {
																		// 	this.props.clearMiniVendors();
																		// }}
																		onMenuScrollToBottom={() => {
																			if (
																				this
																					.props
																					.vendorParams
																					.page <
																				this
																					.props
																					.vendorParams
																					.no_of_pages
																			) {
																				this.props.getMiniVendors(
																					{
																						...this
																							.props
																							.vendorParams,
																						page:
																							this
																								.props
																								.vendorParams
																								.page +
																							1,
																						page_size: 10,
																					}
																				);
																			}
																		}}
																	/>
																	<span className="text-danger mt-0">
																		{
																			this
																				.props
																				.error_msg
																				?.vendor_ids
																		}
																	</span>
																</FormGroup>
															</Col>
														</Row>
													</Col>
													<Col md={6}>
														<Row>
															<Col
																md={12}
																className="mb-0">
																<FormGroup className="mb-0">
																	<div>
																		<Label
																			htmlFor="customFile"
																			className="col-form-label">
																			Product
																			Image
																		</Label>
																	</div>

																	<div className="product-detail">
																		<div className="mt-2 align-items-center ">
																			<label htmlFor="productCustomFile">
																				{/* <div className="img-icon">
                                        <i className="ri-camera-fill "></i>
                                      </div> */}

																				{
																					$imagePreview
																				}
																			</label>
																			<span className="text-danger mt-0">
																				{
																					this
																						.props
																						.error_msg
																						?.image
																				}
																			</span>
																			<div
																				style={{
																					width: "300px",
																				}}>
																				<CustomInput
																					type="file"
																					className="file-upload"
																					id="productCustomFile"
																					accept="image/*"
																					multiple={
																						false
																					}
																					onChange={(
																						e
																					) =>
																						this.handleImageChange(
																							e
																						)
																					}
																					validate={{
																						required:
																							{
																								value: true,
																							},
																						// pattern: { value: "^[A-Za-z0-9]+$" },
																						// minLength: { value: 6 },
																						// maxLength: { value: 16 },
																					}}
																				/>
																			</div>

																			{/* <CustomInput
                                        type="file"
                                        className="file-upload"
                                        id="productCustomFile"
                                        accept="image/*"
                                        multiple={false}
                                        onChange={(e) =>
                                          this.handleImageChange(e)
                                        }
                                        validate={{
                                          required: { value: true },
                                          // pattern: { value: "^[A-Za-z0-9]+$" },
                                          // minLength: { value: 6 },
                                          // maxLength: { value: 16 },
                                        }}
                                      /> */}
																		</div>
																	</div>
																</FormGroup>
															</Col>
														</Row>
													</Col>
												</Row>
												<Row className="mt-2">
													<Col md={12}>
														<h3 className="card-title-15">
															Specifications
														</h3>
													</Col>
													<Col
														md={10}
														className="mb-0">
														<FormGroup className="mb-0">
															<AvField
																className="mb-0 form-control "
																type="textarea"
																value={
																	this.props
																		.rowdata
																		?.description
																}
																onChange={
																	this
																		.ChangeHandeler
																}
																id="Product-Specifications-text-input"
																name="description"
																placeholder="Product Specifications"
																// rows="7"
																// validate={{
																//   required: { value: true },
																//   // pattern: { value: "^[A-Za-z0-9]+$" },
																//   // minLength: { value: 6 },
																//   // maxLength: { value: 16 },
																// }}
															/>
														</FormGroup>
													</Col>
												</Row>
												<Row className="mt-2">
													<Col md={12}>
														<h3 className="card-title-15">
															Units Conversion
														</h3>
														<hr className="my-1" />
													</Col>
												</Row>
												<Row>
													<Col xs={10}>
														<Row>
															<Col md={3}>
																<Button
																	type="button"
																	color="primary"
																	className="btn btn-primary mb-0 mt-2"
																	onClick={() =>
																		this.props.units_model_open()
																	}
																	disabled={
																		this
																			.props
																			.rowdata
																			.units
																			.length ===
																		0
																			? true
																			: false
																	}>
																	Add Units
																</Button>
															</Col>
															<Col md={9}>
																<FormGroup
																	row
																	className="mb-0 mt-2">
																	<Col md={4}>
																		<Label
																			htmlFor="basename"
																			className="col-form-label float-right">
																			Basic
																			Unit
																		</Label>
																	</Col>

																	<Col md={8}>
																		<Select
																			id="basename"
																			name="basename"
																			classNamePrefix="select2-selection"
																			isDisabled={
																				this
																					.state
																					.id !==
																				0
																					? true
																					: false
																			}
																			options={this.props.BasicUnitlist.map(
																				(
																					item,
																					index
																				) => ({
																					label: item.name,
																					value: item.id,
																				})
																			)}
																			value={{
																				label:
																					this
																						.props
																						.rowdata
																						.units
																						.length !==
																					0
																						? this
																								.props
																								.rowdata
																								.baseunitLabel
																						: "Select Units",
																				value:
																					this
																						.props
																						.rowdata
																						.units
																						.length !==
																					0
																						? this
																								.props
																								.rowdata
																								.baseunit_id
																						: null,
																			}}
																			onChange={(
																				e
																			) => {
																				this.props.BaseunitSelecteChangeValue(
																					{
																						key: "baseunitLabel",
																						label: e.label,
																						key2: "baseunit_id",
																						value: e.value,
																					}
																				);
																				// this.gridApi.setRowData([
																				//   {
																				//     name: e.label,
																				//     units: 1,
																				//   },
																				// ]);
																			}}
																		/>
																		<span className="text-danger mt-0">
																			{
																				this
																					.props
																					.error_msg
																					?.baseunit_id
																			}
																		</span>
																	</Col>
																</FormGroup>
															</Col>
														</Row>
														<div
															className="table-responsive mt-2"
															style={{
																maxHeight:
																	"550px",
																overflowY:
																	"auto",
															}}>
															<Table
																// striped
																bordered
																hover
																responsive
																className="mb-0 p-0 table-centered">
																<thead className="bg-light text-center">
																	<tr>
																		<th className="nowrap">
																			Units
																		</th>
																		<th className="nowrap">
																			Conversion
																		</th>
																		<th className="nowrap">
																			Action
																		</th>
																	</tr>
																</thead>
																<tbody>
																	{this.props
																		.rowdata
																		.units
																		.length !==
																	0 ? (
																		<>
																			{this.props.rowdata?.units?.map(
																				(
																					unit,
																					key
																				) => (
																					<tr
																						key={
																							key
																						}>
																						<td className="text-center">
																							{
																								unit.name
																							}
																						</td>
																						<td>
																							<h5 className="font-size-14 text-center ">
																								{
																									unit.units
																								}
																							</h5>
																						</td>

																						<td className="nowrap text-center">
																							<Button
																								disabled={
																									key ===
																										0 ||
																									unit.dodelete ==
																										null ||
																									unit.dodelete
																										? true
																										: false
																								}
																								color="danger"
																								onClick={() =>
																									this.deleteUnits(
																										key
																									)
																								}>
																								<i
																									className="mdi mdi-delete font-size-14"
																									title="Delete Units"
																									style={{
																										cursor: "pointer",
																										color: "##fffff",
																									}}></i>
																							</Button>
																						</td>
																					</tr>
																				)
																			)}
																		</>
																	) : (
																		<>
																			<tr>
																				<td
																					colSpan={
																						6
																					}>
																					<div className="text-center">
																						<span className="font-size-14 text-danger">
																							Select
																							Base
																							Unit
																						</span>
																					</div>
																				</td>
																			</tr>
																		</>
																	)}
																</tbody>
															</Table>
														</div>
													</Col>
												</Row>
												<CardFooter className="bg-transparent pt-3">
													<div className="float-right">
														<Button
															type="submit"
															color="primary"
															className="mr-2">
															Save
														</Button>
														{this.state.bymodel ==
															null && (
															<Button
																type="button"
																color="light"
																href="/Products">
																Cancel
															</Button>
														)}
														{this.state.bymodel && (
															<Button
																type="button"
																color="light"
																onClick={
																	this.props
																		.Close
																}>
																Cancel
															</Button>
														)}
													</div>
												</CardFooter>
											</CardBody>
										</Col>
									</Row>
								</CardBody>
							</AvForm>
						</Card>

						<Modal
							isOpen={this.props.unitsModel}
							backdrop="static"
							centered
							zIndex="9999">
							<ModalHeader
								toggle={() => this.props.units_model_close()}>
								ADD UNITS
							</ModalHeader>
							<AvForm
								className="form-horizontal"
								onValidSubmit={this.handleUnitsSubmit}>
								<ModalBody>
									<Row className="justify-content-center">
										<Col md={10}>
											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="UnitsName"
														className="col-form-label float-right">
														Units Name
													</Label>
												</Col>
												<Col md={8}>
													<AvField
														className="form-control mb-0"
														type="text"
														value={
															this.props
																.ProductUnits
																.name
														}
														onChange={(e) =>
															this.UnitsChangeHandeler(
																e
															)
														}
														id="Units-Name-text-input"
														name="name"
														placeholder="Units Name"
														validate={{
															required: {
																value: true,
															},
														}}
													/>
												</Col>
											</FormGroup>
											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="GroupName"
														className="col-form-label float-right">
														Units Value
													</Label>
												</Col>
												<Col md={8}>
													<AvField
														name="units"
														type="number"
														className="form-control"
														value={
															this.props
																.ProductUnits
																.units
														}
														onChange={(e) =>
															this.UnitsChangeHandeler(
																e
															)
														}
														id="UnitsValue"
														placeholder="Enter Units"
														errormessage=" Please provide a valid units"
														validate={{
															required: {
																value: true,
															},
														}}
													/>
												</Col>
											</FormGroup>
										</Col>
									</Row>

									<ModalFooter>
										<Button
											type="button"
											className="btn btn-danger"
											color="light"
											onClick={() =>
												this.props.units_model_close()
											}>
											Close
										</Button>
										<Button
											type="submit"
											className="btn btn-primary"
											color="primary">
											Save
										</Button>
									</ModalFooter>
								</ModalBody>
							</AvForm>
						</Modal>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}
const mapStatetoProps = (state) => {
	const { changeItem } = state.Materialrequest;
	const {
		deparmentslist,
		vendorslist,
		vendorsLoading,
		vendorParams,
		sectionlist,
		categoryList,
		BasicUnitlist,
		Taxlist,
	} = state.Mini;

	const {
		error_msg,
		rowdata,
		grouprowdata,
		grouplist,
		image,
		model,
		unitsModel,
		ProductUnits,
	} = state.Product;
	return {
		changeItem,
		error_msg,
		rowdata,
		grouprowdata,
		image,
		model,
		unitsModel,
		deparmentslist,
		grouplist,
		vendorslist,
		vendorsLoading,
		vendorParams,
		sectionlist,
		categoryList,
		BasicUnitlist,
		Taxlist,
		ProductUnits,
	};
};
function numberParser(params) {
	return Number(params.newValue);
}

export default connect(mapStatetoProps, {
	getProductGroupsList,
	ProductChangeValue,
	ProductSelecteChangeValue,
	BaseunitSelecteChangeValue,
	ProductUnitsValue,
	ProductVendorsValue,
	ProductImage,
	ProductGroupValue,
	ProductAdd,
	getProductRowData,
	GroupChangeValue,
	pGroupModel_open,
	model_close,
	units_model_open,
	units_model_close,
	getMiniDepartment,
	getMiniVendors,
	getMiniSections,
	getMiniCategorys,
	getMiniTaxs,
	getMiniBasicUnits,
	apiError,
	UnitsChangeValue,
	DeleteUnitsRow,
})(AddProducts);
